export class Contract {
  id: string;
  niveauCarbDepart: number;
  niveauCarbRetour: number;
  kmRetour: number;
  kmDepart: number;
  numeroContrat: string;
  email: any;
  intituleClient: string;
  retour: Date;
  depart: Date;
  cleDocuemnt: number;
  materielCle: number;
  conducteur: string;

  constructor() { }

}

export class ChecklistItem {
  categorieCle: number;
  libelle: string;
  code: string;
  recopie: boolean;
  updateAt: Date | string;
  obligatoire: boolean;
  type: string;
  createdAt: Date | string;
  cle: number;
  reponse: string;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/model/hitech.ts